import { Device } from 'DeviceUtils';
import { Platform, StyleSheet } from 'react-native';
import Theme from 'Theme';

const defaultStyles = {
    container: {
        backgroundColor: '#000000',
        height: Device.isTabletOrWeb ? 60 : Theme.playerHeaderHeight,
        flex: 1,
        alignSelf: 'stretch',
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: Platform.OS === 'ios' ? 15 : 30,
        width: '100%'
    },
    backIconContainer: {
        flexDirection: 'row',
        alignSelf: 'center'
    },
    backIcon: {
        width: 29,
        height: 29,
        alignSelf: 'center',
        marginEnd: 15
    },
    divider: {
        width: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        height: Theme.BU * 2,
        marginEnd: 15
    },
    channelIcon: {
        width: 30,
        height: 30,
        alignItems: 'center',
        marginEnd: 15
    },
    title: {
        flex: 8,
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: Device.isTabletOrWeb ? 21 : 28
    },
    iconsContainer: {
        display: 'flex',
        flex: 2,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: Device.isTabletOrWeb ? 'space-evenly' : 'flex-end'
    },
    icon: {
        width: 29,
        height: 29,
        marginRight: 35,
        marginLeft: 0,
        justifyContent: 'center'
    },
    iconScale: {
        width: 28,
        height: 21,
        marginLeft: 0,
        borderWidth: 1.5,
        borderRadius: 3,
        borderColor: 'white',
        alignItems: 'center',
        justifyContent: 'center'
    },
    iconScaleText: {
        color: 'white',
        fontSize: 7,
        fontWeight: 'bold'
    },
    textIcon: {
        marginRight: 20
    },
    lastIcon: {
        marginRight: 0
    }
};

if (Device.isWeb) {
    defaultStyles.iconsContainer = {
        ...defaultStyles.iconsContainer,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    };
    defaultStyles.icon = {
        ...defaultStyles.icon,
        marginLeft: 20
    };
    defaultStyles.textIcon = {
        ...defaultStyles.textIcon,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        marginLeft: 20
    };
}
const styles = StyleSheet.create(defaultStyles as any);

export default styles;
